
@switch (columnId) {
  @case (MerchantChangeOrderByEnum.CreatedUtc) {
    <lib-date-time-label [dateUtc]="element.createdUtc"></lib-date-time-label>
  }
  @case ('userEmail') {
    <lib-text-table-column>
      {{ element.userEmail }}
    </lib-text-table-column>
  }
  @case ('description') {
    <lib-text-table-column>
      {{ element.description }}
    </lib-text-table-column>
  }
  @default {
  }
}





